<div class="iframe-page">

  <div class="aifs-info-card">
    <div class="aifs-card-header">
      <div class="aifs-header-left">
        <h2 class="aifs-title">{{ config.title }}</h2>
        <div class="aifs-subtitle-row">
          <span class="aifs-subtitle">{{ config.subtitle }}</span>
          <span class="toggle-inline" (click)="toggleInfo()">
            <svg class="chevron" [class.up]="infoExpanded" viewBox="0 0 12 12" fill="none">
              <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ infoExpanded ? config.showLessText : config.showMoreText }}
          </span>
        </div>
      </div>
    </div>

    <div class="aifs-divider" *ngIf="infoExpanded"></div>

    <div class="aifs-info-content" *ngIf="infoExpanded">
<p *ngFor="let paragraph of config.paragraphs">
  <ng-container *ngFor="let part of paragraph">
    <a
      *ngIf="part.href; else plainText"
      [href]="part.href"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ part.text }}
    </a>

    <ng-template #plainText>{{ part.text }}</ng-template>
  </ng-container>
</p>
<!-- closure text -->
 <div class="closure-up">


<div class="closure-wrapper" *ngIf="iframeChecked">
  <img
    *ngIf="config.closureIconPath"
    class="closure-icon"
    [src]="config.closureIconPath"
    alt="DeltaTwin advanced analysis icon"
  />

  <span class="closure-text">
    <ng-container *ngFor="let part of config.closure">
      <a
        *ngIf="part.href; else closurePlain"
        [href]="part.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ part.text }}
      </a>

      <ng-template #closurePlain>
        {{ part.text }}
      </ng-template>
    </ng-container>
  </span>
</div>
 </div>
<div class="aifs-divider" *ngIf="infoExpanded"></div>



<!-- meta-data -->
<div class="aifs-meta-row">
  <div class="aifs-meta-item" *ngFor="let item of config.metadata">
    <span class="meta-label">{{ item.label }}</span>

    <span class="meta-value">
      <a
        *ngIf="item.href; else metaPlain"
        [href]="item.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ item.value }}
      </a>

      <ng-template #metaPlain>{{ item.value }}</ng-template>
    </span>
  </div>

  <div class="aifs-meta-item licenses">
    <span class="meta-label">{{ config.licenses.label }}</span>

    <div class="aifs-license-row">
      <p *ngFor="let license of config.licenses.items">
        <ng-container *ngFor="let part of license">
          <a
            *ngIf="part.href; else licensePlain"
            [href]="part.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{part.text}}
          </a>

          <ng-template #licensePlain>{{ part.text }}</ng-template>
        </ng-container>
      </p>
    </div>
  </div>
</div>



    </div>
  </div>


<!-- Iframe page -->
<div class="iframe-wrapper">
  <ng-container *ngIf="iframeChecked">
  <iframe
    *ngIf="iframeAvailable; else iframeUnavailable"
    #aifsFrame
    [src]="iframeUrl"
    (load)="applyIframeTheme()">
  </iframe>

  <ng-template #iframeUnavailable>
<div class="iframe-unavailable">
  <p>{{ config.unavailableTitle }}</p>
  <span>{{ config.unavailableSubtitle }}</span>
</div>
  </ng-template>
</ng-container>
</div>

<div class="closure-down">
  <div class="closure-wrapper" *ngIf="iframeChecked">
  <span class="closure-text">
    <ng-container *ngFor="let part of config.closure">
      
      <a 
        *ngIf="part.href; else closurePlain"
        [href]="part.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ part.text }}
      </a>

      <ng-template #closurePlain>
        {{ part.text }}
      </ng-template>

    </ng-container>
  </span>
</div>
 
</div>



  <div class="footer-hover-zone"></div>
</div>